// extracted by mini-css-extract-plugin
export var section = "l_d";